"use client";

import LandingExperience from "./LandingExperience";

export default function LandingV3() {
  return <LandingExperience />;
}
